import { useCallback, useMemo } from "react"
import { MULTI_SELECT_KEYS } from "../../constants"

function formatField(value) {
    if (value === undefined || value === null) return ""
    return String(value).toUpperCase()
}

function useFilteredData(data = [], selections = {}) {
    const searchQuery = useMemo(
        () => (selections.searchQuery ?? "").toUpperCase(),
        [selections.searchQuery]
    )
    const ct = selections.ct ?? { fromValue: 0, toValue: 3 }
    const multiSelectSets = useMemo(
        () => MULTI_SELECT_KEYS.map((selector) => {
            const selectionSet = selections[selector]
            return selectionSet instanceof Set ? selectionSet : new Set()
        }),
        [selections]
    )
    const filterData = useCallback((item) => {
        const fieldMatchesSearch = !searchQuery ||
            [item?.stock_no, item?.report_no].some(
                (field) => formatField(field).includes(searchQuery)
            )
        const itemCt = Number(item?.ct)

        const matchesMultiSelect = MULTI_SELECT_KEYS.every((selector, index) => {
            const set = multiSelectSets[index]
            if (!set || set.size === 0) return true
            return set.has(item?.[selector])
        })

        return (
            fieldMatchesSearch
            && ct.fromValue <= itemCt
            && itemCt <= ct.toValue
            && matchesMultiSelect
        )
    }, [ct.fromValue, ct.toValue, multiSelectSets, searchQuery])

    return useMemo(
        () => data.filter(filterData),
        [data, filterData]
    )
}


export default useFilteredData;
